import { render, staticRenderFns } from "./MotorBikeRightRearBreakLight.vue?vue&type=template&id=7945fd1d"
import script from "./MotorBikeRightRearBreakLight.vue?vue&type=script&lang=js"
export * from "./MotorBikeRightRearBreakLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports